import { BaseUIElement } from './baseUIElement';
import { Notification } from '../..';
import { IUIElementOptions } from '../../../interfaces/options';
import { NotificationType } from '../../../enums';
import { Templates } from '../../../compile';

export class NotificationElement extends BaseUIElement {
	private notification: Notification;
	constructor(id: string, label: string, notification: Notification, options?: IUIElementOptions) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				template: Templates.layouts_uiElements_onlyWidget,
				widget: {
					template: Templates.layouts_uiElements_simpleWidget,
					widget: Templates.widgets_notification
				},
				visible: notification.visible
			},
			options || {}
		);
		super(id, label, options);
		this.notification = notification;
	}
	public setType(type: NotificationType) {
		this.notification.setType(type);
	}
	public setText(text: string) {
		this.notification.setText(text);
	}
	public notify(text: string, type: NotificationType = NotificationType.Hint) {
		this.setText(text);
		this.setType(type);
	}
}
